'use client'

import Header from "@/components/layout/authentication-header/header";
import Footer from "@/components/layout/footer/footer";
import { Box, Stack } from "@mui/material";
import dynamic from "next/dynamic";
import React from "react";
const Title = dynamic(() => import('@/components/pages/authentication/title'), { ssr: false });

export default function MainContainer({
    children
}: {
    children: React.ReactNode
}) {
    return <>
        <Box
            minHeight={'100vh'}
            sx={{
                display: 'flex',
                flexDirection: 'column',
                overflow: 'hidden'
            }}
        >
            <Header />
            <Box
                height={'100%'}
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    overflow: 'hidden',
                    backgroundImage: `url(/Group.svg)`,
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                    flex: 1
                }}
            >
                <Box
                    height={'100%'}
                    flex={1}
                    paddingX={{ lg: 10, xs: 2, md: 2, sm: 2 }}
                >
                    <Stack
                        paddingTop={1}
                        useFlexGap
                        direction={{ lg: 'row' }}
                        rowGap={4}
                        justifyContent={'space-between'}
                    >
                        <Title />
                        <Box
                            marginBottom={4}
                            padding={4}
                            minWidth={{ lg: '600px', sm: '100%', xs: '100%', md: '100%' }}
                            sx={{
                                boxShadow: '0px 3px 14px 2px rgba(0, 0, 0, 0.12), 0px 8px 10px 1px rgba(0, 0, 0, 0.14), 0px 5px 5px -3px rgba(0, 0, 0, 0.20)',
                                borderRadius: '12px',
                                backgroundColor: '#FFF'
                            }}
                        >
                            {children}
                        </Box>

                    </Stack>
                </Box>
                <Footer />
            </Box>
        </Box>
    </>
};